export default __webpack_public_path__ + "static/thank_you-f856cf784d65221fd4bcbe06f0c5bdda.png";